var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("picture", [
    _vm.webpSrcSet
      ? _c("source", {
          attrs: { "data-srcset": _vm.webpSrcSet, type: "image/webp" }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("img", {
      class: _vm.classes,
      style: _vm.inlineStyles,
      attrs: {
        src: _vm.placeHolder,
        "data-srcset": _vm.jpgSrcSet,
        "data-sizes": "auto",
        alt: _vm.alt
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }